import { TranslationsKeys } from '../constant';
export const OIDC = {
    fields: [
        {
            testId: 'connectionNameTestId',
            type: 'text',
            id: 'connectionName',
            label: TranslationsKeys.OIDC_CONNECTION_NAME_LABEL,
            helpText: TranslationsKeys.OIDC_CONNECTION_NAME_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_CONNECTION_NAME_ERROR_TEXT,
            refName: 'connectionName',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'clientSecret',
            type: 'text',
            id: 'clientSecret',
            label: TranslationsKeys.OIDC_CLIENT_SECRET_LABEL,
            helpText: TranslationsKeys.OIDC_CLIENT_SECRET_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_CLIENT_SECRET_ERROR_TEXT,
            refName: 'clientSecret',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'ClientIdTestId',
            type: 'text',
            id: 'clientId',
            label: TranslationsKeys.OIDC_CLIENT_ID_LABEL,
            helpText: TranslationsKeys.OIDC_CLIENT_ID_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_CLIENT_ID_ERROR_TEXT,
            refName: 'IDPClientId',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'scopesTestId',
            type: 'text',
            id: 'scopes',
            label: TranslationsKeys.OIDC_SCOPES_LABEL,
            helpText: TranslationsKeys.OIDC_SCOPES_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_SCOPES_ERROR_TEXT,
            refName: 'scopes',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
    ],
};
export const GENERIC = {
    fields: [
        ...OIDC.fields,
        {
            testId: 'authorizationEndpointTestId',
            type: 'text',
            id: 'authorizationEndpoint',
            label: TranslationsKeys.OIDC_AUTHORIZATION_LABEL,
            helpText: TranslationsKeys.OIDC_AUTHORIZATION_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_AUTHORIZATION_ERROR_TEXT,
            refName: 'authorizationEndpoint',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'tokenEndpointTestId',
            type: 'text',
            id: 'tokenEndpoint',
            label: TranslationsKeys.OIDC_TOKEN_ENDPOINT_LABEL,
            helpText: TranslationsKeys.OIDC_TOKEN_ENDPOINT_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_TOKEN_ENDPOINT_ERROR_TEXT,
            refName: 'tokenEndpoint',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'issuerTestId',
            type: 'text',
            id: 'issuer',
            label: TranslationsKeys.OIDC_ISSUER_LABEL,
            helpText: TranslationsKeys.OIDC_ISSUER_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_ISSUER_ERROR_TEXT,
            refName: 'issuer',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
        {
            testId: 'userinfoEndpointTestId',
            type: 'text',
            id: 'userinfoEndpoint',
            label: TranslationsKeys.OIDC_USER_INFO_LABEL,
            helpText: TranslationsKeys.OIDC_USER_INFO_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_USER_INFO_ERROR_TEXT,
            refName: 'userinfoEndpoint',
            is_invalid: (value) => {
                return false;
            },
        },
        {
            testId: 'jwksEndpointTestId',
            type: 'text',
            id: 'jwksEndpoint',
            label: TranslationsKeys.OIDC_JWKS_ENDPOINT_LABEL,
            helpText: TranslationsKeys.OIDC_JWKS_ENDPOINT_HELP_TEXT,
            errorText: TranslationsKeys.OIDC_JWKS_ENDPOINT_ERROR_TEXT,
            refName: 'jwksEndpoint',
            is_invalid: (value) => {
                return !value || value.length === 0;
            },
        },
    ],
};
//# sourceMappingURL=oidc-form-config.js.map